module.exports = __webpack_public_path__ + "media/images/flags/64/Mauritius-036fd53da85af38c1112c130260f0a39.png";